import { IconSvg, IconSvgProps } from "./icon"

export default function Eye(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M11.875 15.6424C13.0652 15.6424 14.03 14.6776 14.03 13.4875C14.03 12.2973 13.0652 11.3325 11.875 11.3325C10.6849 11.3325 9.72009 12.2973 9.72009 13.4875C9.72009 14.6776 10.6849 15.6424 11.875 15.6424Z" />
      <path
        d="M18.3992 12.7557C18.7947 13.1861 18.7947 13.7887 18.3992 14.2191C17.3118 15.4243 14.8404 17.8346 11.8748 17.8346C8.90916 17.8346 6.4378 15.5104 5.3504 14.2191C4.95498 13.7887 4.95498 13.1861 5.3504 12.7557C6.4378 11.5506 8.90916 9.14026 11.8748 9.14026C14.8404 9.14026 17.3118 11.5506 18.3992 12.7557Z"
        strokeMiterlimit="10"
      />
    </IconSvg>
  )
}
